import { render, staticRenderFns } from "./user-group-courier-editor.vue?vue&type=template&id=9344b7ca&scoped=true&"
import script from "./user-group-courier-editor.vue?vue&type=script&lang=ts&"
export * from "./user-group-courier-editor.vue?vue&type=script&lang=ts&"
import style0 from "./user-group-courier-editor.vue?vue&type=style&index=0&id=9344b7ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9344b7ca",
  null
  
)

export default component.exports